/* eslint-disable import/no-deprecated */
import type { LineageTableId, LineageUriId } from "./type";

export const isEqualTables = (
  a: LineageTableId | LineageUriId,
  b: LineageTableId | LineageUriId,
): boolean => a.identifier_type === b.identifier_type && a.identifier === b.identifier;
